/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCellReviewRequest from './AqaCellReviewRequest';

/**
 * The AqaRecordReviewRequest model module.
 * @module model/AqaRecordReviewRequest
 * @version v0
 */
export default class AqaRecordReviewRequest {
  /**
   * Constructs a new <code>AqaRecordReviewRequest</code>.
   * @alias module:model/AqaRecordReviewRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaRecordReviewRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaRecordReviewRequest} obj Optional instance to populate.
   * @return {module:model/AqaRecordReviewRequest} The populated <code>AqaRecordReviewRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaRecordReviewRequest();
      if (data.hasOwnProperty('cellReviewRequests'))
        obj.cellReviewRequests = ApiClient.convertToType(data['cellReviewRequests'], {'String': AqaCellReviewRequest});
    }
    return obj;
  }
}

/**
 * @member {Object.<String, module:model/AqaCellReviewRequest>} cellReviewRequests
 */
AqaRecordReviewRequest.prototype.cellReviewRequests = undefined;

